import { watch } from "vue";

export interface ExclusiveDrawer {
    drawerOpen: boolean;
    closeDrawer: () => void;
}

/**
 * Keeps a set of right-side panels mutually exclusive: opening any one of them
 * closes the others.
 *
 * Only panels that are ACTUALLY open are closed. `closeDrawer` is not assumed
 * to be idempotent or free — a member may implement it as something with side
 * effects (a route change, a request), so calling it on an already-closed
 * panel is not a harmless no-op.
 *
 * Scoped to the caller's effect scope, so the watchers stop with the component
 * that registered them.
 */
export const useExclusiveRightDrawers = (drawers: ExclusiveDrawer[]) => {
    drawers.forEach((drawer, index) => {
        const others = drawers.filter((_, otherIndex) => otherIndex !== index);
        watch(
            () => drawer.drawerOpen,
            (open) => {
                if (!open) return;
                others.forEach((other) => {
                    if (other.drawerOpen) other.closeDrawer();
                });
            }
        );
    });
};
